// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"31d6cfe0","271":"1126b8a7","309":"c4d267c1","621":"f9d60151","739":"6f0841a2"}[chunkId] + ".chunk.css";
};